/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Order_Product_Stock_BadgeInputs */

const vi_order_product_stock_badge = /** @type {(inputs: Order_Product_Stock_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số lượng: ${i?.qty} ${i?.unit}`)
};

/**

* @param {Order_Product_Stock_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_product_stock_badge = /** @type {((inputs: Order_Product_Stock_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Product_Stock_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_product_stock_badge(inputs)
});